import { apiClient, ApiResponse } from '@/features/shared/api/apiClient';
import type { PermissionDto, PermissionHistoryDto } from '../types';

class PermissionService {
  async getAllPermissions(): Promise<PermissionDto[]> {
    const { data } = await apiClient.get<ApiResponse<PermissionDto[]>>('/authorization/permissions');
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch permissions');
  }

  async getPermissionHistory(roleId: number): Promise<PermissionHistoryDto[]> {
    const { data } = await apiClient.get<ApiResponse<PermissionHistoryDto[]>>(
      `/authorization/roles/${roleId}/permissions/history`
    );
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch permission history');
  }
}

export const permissionService = new PermissionService();
